import { useQuery } from '@tanstack/vue-query';
import { computed } from 'vue';
import { useUserStore } from '/@stores/user';
import { Qualification } from '/@types/qualification';
import { RolePermission } from '/@types/user';
import api from '/@utilities/http';

export function useQualificationsQuery() {
  const userStore = useUserStore();

  const enabled = computed(() => userStore.hasRolePerm(RolePermission.QualificationUser));

  return useQuery<Qualification[]>({
    queryFn: () => api.get(`/qualifications`).then((response) => response.data),
    queryKey: ['qualifications'],
    enabled,
  });
}
